module.exports = function() {
  return new Worker(__webpack_public_path__ + "fe0c663d5aef6792b6ce.worker.js");
};